import { ShieldAlert, Scale, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../components/ui/Badge';
import { formatSyncTimestamp } from '../../../components/ui/SyncTimestamps';
import { STATUS_MAP, getStep, fmtEur, fmtDate } from '../utils';
import { ProgressBar } from './ProgressBar';

export function ClaimRow({ claim, onClick }) {
  const { t, i18n } = useTranslation();
  const locale      = i18n.language;
  const isSinistre  = claim.claimType === 'sinistre';
  const { current, total } = getStep(claim.status, isSinistre);
  const statusDef   = STATUS_MAP[claim.status] || STATUS_MAP.open;

  return (
    <button
      className="w-full text-left px-5 py-4 hover:bg-slate-50 flex items-start gap-4 transition"
      onClick={onClick}
    >
      <span className={`w-10 h-10 rounded-lg grid place-items-center mt-0.5 flex-shrink-0 ${
        isSinistre ? 'bg-rose-50 text-rose-600' : 'bg-violet-50 text-violet-600'
      }`}>
        {isSinistre ? (
          <ShieldAlert size={18} strokeWidth={1.75} />
        ) : (
          <Scale size={18} strokeWidth={1.75} />
        )}
      </span>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <span className="font-mono font-semibold text-[12.5px]">{claim.reference || '—'}</span>
          <Badge variant={statusDef.variant}>{t(`claims.${statusDef.labelKey}`)}</Badge>
        </div>
        <div className="font-semibold text-[13.5px] text-slate-900">{claim.subject || '—'}</div>
        <div className="text-[11.5px] text-slate-500 mt-0.5">
          {[
            claim.companyName,
            claim.openedAt && `${t('claims.opened_on')} ${fmtDate(claim.openedAt, locale)}`,
            isSinistre && claim.insurer && `${t('claims.insurer')} ${claim.insurer}`,
          ].filter(Boolean).join(' · ')}
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-500 mt-1">
          <span>{t('common.created_at')}: {formatSyncTimestamp(claim.createdAt, locale)}</span>
          <span>{t('common.updated_at')}: {formatSyncTimestamp(claim.updatedAt, locale)}</span>
        </div>
        <ProgressBar current={current} total={total} isSinistre={isSinistre} />
      </div>

      <div className="text-right flex-shrink-0">
        <div className="text-[16px] font-semibold tabular-nums">{fmtEur(claim.claimedAmountEur)}</div>
        <div className="text-[10.5px] text-slate-500">{t('claims.amount_label')}</div>
      </div>

      <ChevronRight size={16} strokeWidth={1.75} className="text-slate-400 mt-3 flex-shrink-0" />
    </button>
  );
}
